class Preview {
    constructor(element) {
        this.element = element
        this.source = element.dataset.source
    }

    init() {
        let URL = window.URL || window.webkitURL
        fetch(this.source).then(e => e.blob()).then(e => {
            let b = new Blob([e], {type:'video/mp4'})
            this.element.src = URL.createObjectURL(b)
        })
    }
}

document.addEventListener('DOMContentLoaded', e => {
    let els = document.querySelectorAll('.movie-thumb-preview')
    els.forEach(el => {
        el.preview = new Preview(el)
        el.preview.init()
    })
}, false);

export default Preview
